// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".introduction-section{background-color:#edf2f7;color:#718096}.introduction-section__heading{font-weight:700;font-size:1.5em;line-height:1.25;margin-bottom:1.5em}@media (min-width:40em){.introduction-section__heading{font-size:1.875em}}@media (min-width:64em){.introduction-section__heading{font-size:2.25em}}@media (min-width:40em){.introduction-section__text{font-size:1.25em}}@media (min-width:64em){.introduction-section__text{font-size:1.5em}}", ""]);
// Exports
module.exports = exports;
